// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qDNk","icon":"styles_icon__1Wi8p"};